import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "small fs-16" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_5 = ["data-response-id"]
const _hoisted_6 = ["data-survey-id", "data-step-id", "data-answer-id", "data-answer"]
const _hoisted_7 = { class: "d-flex justify-content-between flex-grow-1 gap-3" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "text-muted fw-medium survey-answer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDIView = _resolveComponent("PDIView")!
  const _component_FKAccordion = _resolveComponent("FKAccordion")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responses, (instance) => {
    return (_openBlock(), _createBlock(_component_FKAccordion, {
      id: `surveys-${_ctx.survey.id}-${instance.id}`,
      class: "mb-2",
      key: instance.id
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(instance.date), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_3, "  - " + _toDisplayString(_ctx.formatTime(instance.created_at)), 1 /* TEXT */),
          (instance.created_by_role === _ctx.role.caregiver)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "  - " + _toDisplayString(_ctx.$t(`feature.roles.$type.${instance.created_by_role}`)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", {
          class: "ps-0 mb-0 list-unstyled",
          "data-response-id": instance.id
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instance.answers, (answer) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "d-flex p-2",
              key: answer.id,
              "data-survey-id": _ctx.survey.id,
              "data-step-id": answer.step_id,
              "data-answer-id": answer.id,
              "data-answer": answer.value_type !== 'PDI' ? answer.value : 'PDI'
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createCommentVNode(" QUESTION "),
                _createElementVNode("span", {
                  class: "fs-md-15 fw-medium text-muted position-relative survey-question",
                  innerHTML: _ctx.$s.getStep(answer.step_id)?.title
                }, null, 8 /* PROPS */, _hoisted_8),
                _createCommentVNode(" ANSWER "),
                _createElementVNode("span", _hoisted_9, [
                  (_ctx.$s.getStep(answer.step_id)?.type === 'PDI')
                    ? (_openBlock(), _createBlock(_component_PDIView, {
                        key: 0,
                        step_id: answer.step_id,
                        points: (_ctx.$s.getAnswer(answer.step_id, instance) as PDIAnswer)
                      }, null, 8 /* PROPS */, ["step_id", "points"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$s.getAnswer(answer.step_id, instance)), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ])
              ])
            ], 8 /* PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_5)
      ]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]))
  }), 128 /* KEYED_FRAGMENT */))
}